<template>
  <div class="content">
    <FollowUpReminderBanner v-if="isOperatorDashboard" />

    <router-view v-slot="{ Component }">
      <transition
        name="fade"
        mode="out-in"
      >
        <component :is="Component" />
      </transition>
    </router-view>

    <ContentFooter />

    <div class="buttons-wrapper">
      <el-tooltip
        v-if="!isUpToDate"
        placement="top"
        popper-class="out-of-date-tooltip"
        :visible="!isUpToDate && isTooltipVisible"
      >
        <template #content>
          <div>New version of the dashboard available!</div>
          <div>Please LOLI at your earliest convenience.</div>
        </template>

        <p-button
          type="danger"
          class="btn-out-of-date"
          round
          @click="moveToBottom"
          @mouseenter="isTooltipVisible = true"
          @mouseleave="isTooltipVisible = false"
        >
          <i class="fa fa-exclamation-triangle" />
        </p-button>
      </el-tooltip>

      <div class="vertical-group">
        <p-button
          v-if="isTopBtnVisible"
          type="yellow"
          class="btn-top"
          round
          @click="moveToTop"
        >
          <i class="fa fa-arrow-up" />
        </p-button>

        <p-button
          v-if="isBottomBtnVisible"
          type="yellow"
          class="btn-bottom"
          round
          @click="moveToBottom"
        >
          <i class="fa fa-arrow-down" />
        </p-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, onMounted } from 'vue';

import util from '@/Utils/util';

import ContentFooter from './ContentFooter.vue';
import FollowUpReminderBanner from './FollowUpReminderBanner.vue';
import { useIsUpToDate } from '@/use/version';
import { useDashboard } from '@/use/app';


export default {
  components: {
    ContentFooter,
    FollowUpReminderBanner,
  },

  setup: () => {
    const { isOperatorDashboard } = useDashboard();
    const { isUpToDate } = useIsUpToDate();
    const isTooltipVisible = ref(true);
    const isTopBtnVisible = ref(false);
    const isBottomBtnVisible = ref(true);

    onMounted(() => {
      const element = document.querySelector('.main-panel .content');
      if (element) {
        element.addEventListener('scroll', () => {
          isTopBtnVisible.value = element.scrollTop > 100 ? true : false;

          // checking scroll is bottom
          if (window.innerHeight + element.scrollTop < element.scrollHeight) {
            isBottomBtnVisible.value = true;
          } else {
            isBottomBtnVisible.value = false;
          }
        });
      }
    });

    const moveToTop = () => {
      util.moveToTop();
    };

    const moveToBottom = () => {
      util.moveToBottom();
    };

    return {
      isTopBtnVisible,
      isBottomBtnVisible,
      isOperatorDashboard,

      util,

      moveToTop,
      moveToBottom,

      isUpToDate,
      isTooltipVisible,
    };
  },
};
</script>

<style lang="scss">
.main-panel {
  & > .content {
    position: relative;
    min-height: calc(100vh - 180px) !important;

    .buttons-wrapper {
      display: flex;
      flex-direction: row;
      align-items: end;
      margin-top: 0;
      margin-right: -20px;
      position: sticky;
      float: right;
      bottom: 0;

      .vertical-group {
        display: flex;
        flex-direction: column;
        gap: 5px;
      }

      .btn {
        min-width: unset;
        padding: 5px 10px !important;
        font-size: 24px !important;
        z-index: 0;
      }
    }
  }
}
.el-popper.out-of-date-tooltip[role='tooltip'] {
  background: #eb6532;
  color: white;
  --el-text-color-primary: #eb6532;
}
</style>
